var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilesAndFolders = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "files-and-folders"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.07207 47.9683H36.3414C37.3613 47.9683 38.2792 47.0522 38.3812 45.9325V10.0009C38.3812 8.88119 37.4633 7.96509 36.3414 7.96509H2.07207C0.950155 7.96509 0.0322266 8.88119 0.0322266 10.0009V45.9325C0.0322266 47.0522 0.950155 47.9683 2.07207 47.9683ZM34.3015 43.9985H4.00992V12.0367H34.3015V43.9985Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M45.9283 40.1304H37.157C36.0351 40.1304 35.1171 39.2143 35.1171 38.0946C35.1171 36.9749 36.0351 36.0588 37.157 36.0588H43.8885V4.09696H13.6988V9.18642C13.6988 10.3061 12.7809 11.2222 11.659 11.2222C10.5371 11.2222 9.61914 10.3061 9.61914 9.18642V2.06118C9.61914 0.941494 10.5371 0.0253906 11.659 0.0253906H45.9283C47.0502 0.0253906 47.9681 0.941494 47.9681 2.06118V37.9928C47.9681 39.2143 47.0502 40.1304 45.9283 40.1304Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M26.8557 22.7244H11.4549C10.333 22.7244 9.41504 21.8083 9.41504 20.6886C9.41504 19.5689 10.333 18.6528 11.4549 18.6528H26.8557C27.9776 18.6528 28.8955 19.5689 28.8955 20.6886C28.8955 21.8083 27.9776 22.7244 26.8557 22.7244Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M26.8557 37.1785H11.4549C10.333 37.1785 9.41504 36.2624 9.41504 35.1427C9.41504 34.023 10.333 33.1069 11.4549 33.1069H26.8557C27.9776 33.1069 28.8955 34.023 28.8955 35.1427C28.8955 36.2624 27.9776 37.1785 26.8557 37.1785Z",
    fill: "currentColor"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilesAndFolders);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/filesAndFolders.276f64cf55edaaa042516c0e08afcb75.svg";